import React from 'react';
import './App.scss';

import Layout from "./components/Layout";
function App() {
  return (
    <Layout/>
  )
}

export default App;
